<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><i>For Bill,</i> <br/><i>Sophia, and Juliet</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// jenn_9781558616912_oeb_ded_r1.vue?1e52fd3a